import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map } from 'rxjs';

export const adminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.getUserInfo().pipe(
    map(userInfo => {
      if (userInfo.claims?.Administrator == 'true') {
    return true;
  }
      router.navigate(['/']);
    return false;
    })
  );
};
